module.exports = __webpack_public_path__ + "static/media/image 44.6cd02df3.png";